import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Icon from "@mdi/react";
// import { mdiPencil, mdiPlus } from "@mdi/js";
import { ModalChiTiet } from "./ModalChiTiet";
import NumberFormat from "react-number-format";

export const BtnChiTiet = ({ item }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };
  return (
    <>
      <a href={() => false} class="iconTable-Main" onClick={toggleModal}>
        {item.TieuDe}
      </a>
      {/* {isModalVisible && ( */}
      <ModalChiTiet isModalVisible={isModalVisible} toggleModal={toggleModal} item={item} />
      {/* )} */}

    </>
  );
};
